import { Box } from "@mui/material";
import { IN_REPAIR_BADGE_BASE_SX, IN_REPAIR_WORKSTREAM_STYLES } from "../data/inRepairListingConstants";

const InRepairWorkstreamBadge = ({ label }) => {
  if (!label) return null;

  const style = IN_REPAIR_WORKSTREAM_STYLES[label] || {
    bg: "#f0eeeb",
    color: "#5a5855",
  };

  return (
    <Box
      component="span"
      sx={{
        ...IN_REPAIR_BADGE_BASE_SX,
        backgroundColor: style.bg,
        color: style.color,
      }}
    >
      {label}
    </Box>
  );
};

export default InRepairWorkstreamBadge;
